


































































































































































































import Vue from 'vue';
import _ from 'lodash';
import store from '@/store';
import { mapState, mapGetters } from 'vuex';
import { ViewpointDao } from "@/api/ViewpointDao";
import ButtonWithConfirmation from "@/components/common/button-with-confirmation.vue";
import { getModule } from "vuex-module-decorators";
import ViewpointsModule from "@/store/viewpoint/viewpoint";
import { Viewpoint } from "@/api/model/Viewpoint";

const viewpointModule = getModule(ViewpointsModule)
export default Vue.extend({

  name: 'ViewpointSelector',

  components: {
    ButtonWithConfirmation,
  },

  props: {
    selectOptions: {
      type: Object,
      default: () => ({
        label: 'Please Select an Item',
      }),
    },
    authorizedActions: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return {
      viewpointForm: {} as any,
      dialogIsEdit: false,
      dialogTitle: '',
      dialog: false,
      disabled: false,
      nameRules: [
        (v: string) => !!v || 'Viewpoint name is required'
      ],
      valid: false,
      message: 'Your Viewpoint is being created ...',
      showMessage: false,
      formSubject: '' as any,
      ruleSubject: [
        (v: any) => !!v || '"Viewpoint Name" is required',
        (v: any) =>
            (v && v.length <= 100) ||
            '"Viewpoint Name" must be less than 100 characters'
      ],
      formBody: '' as any,
      ruleBody: [
        // (v: any) => !!v || '"Description" is required',
        (v: any) =>
            (!v || (v.length <= 500)) ||
            '"Description" must be less than 500 characters'
      ],
    };
  },

  created() {
  },

  mounted() {
  },


  watch: {

    dialog(newVal, oldVal) {
      if (!newVal) {
        this.clearForm();
        this.message = '';
        this.disabled = false;
      }
    },

  },


  computed: {

    deleteDisabled(): boolean {
      return (this.viewpoints.length <= 1);
    },

    selectedViewpointId(): string {
      return viewpointModule.selectedViewpointId
    },

    viewpoints(): Viewpoint[] {
      return viewpointModule.viewpoints
    },
    currentViewpointName(): string {
      let res: any = _.filter(this.viewpoints, {'viewpointId': this.selectedViewpointId});
      if (res.length) {
        return res[0].name;
      }
      return '';
    },

    currentViewpointDescription(): string {
      let res: any = _.filter(this.viewpoints, {'viewpointId': this.selectedViewpointId});
      if (res.length) {
        return res[0].description;
      }
      return '';
    },

    iconSize(): string {
      switch (this.$vuetify.breakpoint.name) {
        case 'md':
        case 'lg':
        case 'xl':
          return '';
        default:
          return 'small';
      }
    },

    thisForm(): Vue & { reset: () => void } {
      return this.$refs.form as Vue & { reset: () => void };
    },

    isValid(): boolean {
      return (this.valid && !!this.formSubject);
    },

  },


  methods: {

    isAuthorized(action: string): boolean {
      return this.authorizedActions.includes(action);
    },

    viewpointSelected(e: any = null) {
      if (e) {
        this.$emit('viewpoint-selected', e)
      } else {
        this.$emit('viewpoint-selected', null)
      }
    },

    createViewpointDialog() {
      this.dialogIsEdit = false;
      this.dialogTitle = 'Create a new Viewpoint'
      this.dialog = true;
    },

    async createViewpoint() {
      if (this.formSubject) {
        this.disabled = true;
        this.message = 'Your Viewpoint is being created.';
        this.showMessage = true;
        let body: any = {
          name: this.formSubject
        };
        if (this.formBody) {
          body.description = this.formBody;
        }
        await viewpointModule.createViewpoint(body)
        this.disabled = false;
        this.showMessage = false;
        this.dialog = false;
      }
      console.log('CREATED Viewpoint');
    },

    attachViewpointDialog() {
      console.log('ATTACH Viewpoint DIALOG');
    },

    attachViewpoint() {
      console.log('ATTACHED Viewpoint');
    },

    editViewpointDialog() {
      this.dialogIsEdit = true;
      this.dialogTitle = 'Edit this Viewpoint';
      this.formSubject = this.currentViewpointName;
      this.formBody = this.currentViewpointDescription;
      this.dialog = true;
    },

    async editViewpoint() {
      if (this.formSubject) {
        this.disabled = true;
        this.message = 'Your Viewpoint is being updated.';
        this.showMessage = true;
        let body: any = {
          name: this.formSubject,
          id: this.selectedViewpointId
        };
        if (this.formBody) {
          body.description = this.formBody;
        } else {
          body.description = null;
        }
        await viewpointModule.updateViewpoint(body)
        this.disabled = false;
        this.showMessage = false;
        this.dialog = false;
      }
      console.log('UPDATED Viewpoint');
    },

    async deleteViewpoint() {
      await viewpointModule.deleteViewpoint(this.selectedViewpointId)
      console.log('DELETED Viewpoint');
    },

    clearForm(): void {
      this.thisForm.reset();
    },


  },


});

